webpackJsonp([1],{

/***/ 100:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 101:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 102:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 103:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 104:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 19:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Home__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Home__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Markdown Home',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Home___default.a
  }, {
    path: '/:plink',
    name: 'Permalink',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Home___default.a,
    props: true
  }, {
    path: '*',
    name: 'Redirect',
    redirect: '/'
  }]
}));

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(100)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(63),
  /* template */
  __webpack_require__(203),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-33d722cc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(104)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(64),
  /* template */
  __webpack_require__(207),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f672dae2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(103)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(206),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(101)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(66),
  /* template */
  __webpack_require__(204),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 203:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('footer', {
    staticClass: "text-center",
    staticStyle: {
      "margin-left": "-35px",
      "margin-right": "-35px",
      "margin-bottom": "-35px"
    },
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "footer-text"
  }, [_vm._v("© " + _vm._s(_vm.getFullYear()) + "\n            "), _c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us"
    }
  }, [_vm._v("Illinois Criminal Justice Information Authority")]), _vm._v("\n            |  \n          "), _c('i', {
    staticClass: "fa fa-github",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                "), _c('a', {
    attrs: {
      "href": "https://github.com/ICJIA/icjia-markdown"
    }
  }, [_vm._v("View on GitHub")])])])])
},staticRenderFns: []}

/***/ }),

/***/ 204:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "margin-top": "45px"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('div', {
    staticClass: "status"
  }, [_c('span', {
    staticClass: "info-text",
    staticStyle: {
      "float": "right",
      "margin-right": "5px",
      "margin-top": "-1px"
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clearStatus($event)
      }
    }
  }, [_vm._v("CLOSE")])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "box-label",
    attrs: {
      "data-intro": "Write your Markdown here"
    }
  }, [_vm._v("MARKDOWN")]), _vm._v(" "), _c('span', {
    staticClass: "info-text",
    staticStyle: {
      "float": "right",
      "margin-left": "2px"
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clear($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Clear")])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.myInput),
      expression: "myInput"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "markdown"
    },
    domProps: {
      "value": (_vm.myInput)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.myInput = $event.target.value
      }, _vm.update]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "box-label",
    attrs: {
      "data-intro": "View your document updates in real-time as you type."
    }
  }, [_vm._v("RESULT")]), _vm._v(" "), _c('span', {
    staticClass: "info-text",
    staticStyle: {
      "float": "right",
      "margin-left": "2px"
    }
  }, [_c('a', {
    attrs: {
      "href": "",
      "data-intro": "View your formatted HTML at any time",
      "data-position": "left"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showHTML($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-code-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" RAW HTML")])]), _vm._v(" "), _c('div', {
    staticClass: "markdown-body",
    attrs: {
      "id": "results"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.compiledMarkdown)
    },
    on: {
      "change": _vm.areaChange
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "margin-top": "40px",
      "margin-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "well text-center",
    staticStyle: {
      "height": "160px"
    },
    attrs: {
      "data-intro": "Have your own Markdown (.md) file? Load it right here.",
      "data-position": "top"
    }
  }, [_c('h4', {
    staticClass: "option-button"
  }, [_vm._v("Load Markdown (.md)")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('input', {
    staticClass: "custom-file-input",
    attrs: {
      "type": "file",
      "id": "fileInput"
    },
    on: {
      "change": _vm.loadMd
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "well text-center",
    staticStyle: {
      "height": "160px"
    },
    attrs: {
      "data-intro": "Ready to export? Save as html, markdown, or plain text.<br><br>Note: All formatting is removed when saved as plain text.",
      "data-position": "top"
    }
  }, [_c('h4', {
    staticClass: "option-button"
  }, [_vm._v("Save Result As ...")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-default btn-save first",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.saveMd($event)
      }
    }
  }, [_vm._v("Markdown (.md)")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-save",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.saveTxt($event)
      }
    }
  }, [_vm._v("Plain Text (.txt)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-default btn-save first",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.saveStyledHtml($event)
      }
    }
  }, [_vm._v("Styled (.html)")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-save",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.saveRawHtml($event)
      }
    }
  }, [_vm._v("Raw (.html)")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "status-text"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "error",
    staticStyle: {
      "color": "red",
      "font-size": "12px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-text hidden-xs",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "left",
      "title": "Tooltip on left"
    }
  }, [_c('a', {
    staticClass: "pop",
    attrs: {
      "href": "",
      "id": "whatIsMarkdown",
      "data-title": "What is Markdown?",
      "data-content": "Markdown is a lightweight markup language with plain text formatting syntax. Markdown is often used to format readme files, to write messages in online discussion forums, and to create rich text using a plain text editor. Markdown is easily converted to HTML.<br/><br/>For more information, please see:<br/><br/><a href='https://en.wikipedia.org/wiki/Markdown'>https://en.wikipedia.org/wiki/Markdown</a><br><br><a href='https://help.github.com/articles/basic-writing-and-formatting-syntax'>https://help.github.com/articles/basic-writing-and-formatting-syntax</a><br><br>",
      "data-placement": "bottom"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" What is Markdown?")])])
}]}

/***/ }),

/***/ 205:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('navbar'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "wrapper"
    }
  }, [_c('div', {
    attrs: {
      "id": "page-content-wrapper"
    }
  }, [_c('sidebar'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('my-footer')], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 206:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    attrs: {
      "id": "sidebar-wrapper"
    }
  }, [_c('ul', {
    staticClass: "sidebar-nav",
    staticStyle: {
      "margin-top": "45px"
    }
  }, [_c('li', {
    staticClass: "sidebar-brand"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                      Save/Load Goes Here\n                  ")])])])])])
}]}

/***/ }),

/***/ 207:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('nav', {
    staticClass: "navbar navbar-inverse navbar-fixed-top"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "bs-example-navbar-collapse-1"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right",
    staticStyle: {
      "margin-right": "20px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_vm._m(2), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.loadBoilerplateEvent('ICJIA Style Guide')
      }
    }
  }, [_vm._v("ICJIA Style Guide")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.loadBoilerplateEvent('What is Markdown?')
      }
    }
  }, [_vm._v("What is Markdown?")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.loadBoilerplateEvent('Getting Started')
      }
    }
  }, [_vm._v("Getting Started")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.loadBoilerplateEvent('Tables')
      }
    }
  }, [_vm._v("Tables")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.loadBoilerplateEvent('Math (using KaTeX)')
      }
    }
  }, [_vm._v("Math (using KaTeX)")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.loadBoilerplateEvent('Fontawesome icons')
      }
    }
  }, [_vm._v("Fontawesome icons")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.loadBoilerplateEvent('Footnotes')
      }
    }
  }, [_vm._v("Footnotes")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.loadBoilerplateEvent('GitHub README')
      }
    }
  }, [_vm._v("GitHub README")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.loadBoilerplateEvent('Images')
      }
    }
  }, [_vm._v("Images")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.loadBoilerplateEvent('Return to page top')
      }
    }
  }, [_vm._v("Return to page top")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.loadBoilerplateEvent('Mixed HTML and Markdown')
      }
    }
  }, [_vm._v("Mixed HTML and Markdown")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.loadBoilerplateEvent('Expandable details')
      }
    }
  }, [_vm._v("Expandable details")])])])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_vm._m(3), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.loadBoilerplateEvent('Privacy 01')
      }
    }
  }, [_vm._v("ICJIA Privacy Policy")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.loadBoilerplateEvent('Article 01')
      }
    }
  }, [_vm._v("ICJIA Article 01")])])])]), _vm._v(" "), _vm._m(4)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#bs-example-navbar-collapse-1",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })]), _vm._v(" "), _vm._v("\n\n             "), _c('span', {
    staticClass: "navbar-brand sidebar-toggle"
  }, [_c('i', {
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-header"
  }, [_vm._v("  ICJIA Markdown Editor\n          ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "menu-item",
    attrs: {
      "href": "http://www.icjia.state.il.us/sandbox/typography",
      "target": "_blank"
    }
  }, [_vm._v("ICJIA STYLE GUIDE  "), _c('i', {
    staticClass: "fa fa-external-link",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle menu-item",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("Examples "), _c('span', {
    staticClass: "caret"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle menu-item",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("Boilerplate "), _c('span', {
    staticClass: "caret"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticStyle: {
      "margin": "0",
      "padding": "0"
    },
    attrs: {
      "href": "http://www.icjia.state.il.us"
    }
  }, [_c('img', {
    staticStyle: {
      "margin-top": "16px",
      "margin-left": "12px"
    },
    attrs: {
      "src": "/static/logos/icjia1.png",
      "height": "20"
    }
  })])])
}]}

/***/ }),

/***/ 25:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);

var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/***/ }),

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
////////////////////////////////////////////////////////////////////////////////////
// Custom Google Analytics injection. Modified from vue-ga
////////////////////////////////////////////////////////////////////////////////////


function appendScript() {
  var script = document.createElement('script');
  script.async = true;
  script.src = 'https://www.google-analytics.com/analytics.js';
  document.body.appendChild(script);
}

function stripTrailingSlash(str, min) {
  if (str.substr(-1) === '/' && str.length > min) {
    return str.substr(0, str.length - 1);
  } else {
    return str;
  }
}

function init(id) {
  if (!window.ga) {
    appendScript();
    window.ga = window.ga || function () {
      (ga.q = ga.q || []).push(arguments);
    };
    ga.l = Number(new Date());
    ga('create', id, 'auto');
  }
}

function collect(id, prefix, title, path) {
  init(id);
  ga('set', 'page', path);
  ga('set', 'title', prefix + title);
  ga('send', 'pageview');
}

/* harmony default export */ __webpack_exports__["a"] = (function (id, prefix, router) {

  router.afterEach(function (from) {
    var routes = router.options.routes;
    var title = '(undefined)';
    var path = '(undefined)';
    var name = '(undefined)';
    console.log(routes[0].path);
    //console.table(routes)
    for (var o = 0; o < routes.length; o++) {
      if (routes[o].path === stripTrailingSlash(from.fullPath, 1)) {
        title = routes[o].title;
        path = routes[o].path;
        name = routes[o].name;
      }
    }

    collect(id, prefix, name, path);
  });
});

/***/ }),

/***/ 42:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(102)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(205),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 62:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navbar__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Navbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Sidebar__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Footer__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Footer__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_0__components_Navbar___default.a,
    MyFooter: __WEBPACK_IMPORTED_MODULE_2__components_Footer___default.a,
    Sidebar: __WEBPACK_IMPORTED_MODULE_1__components_Sidebar___default.a
  }
});

/***/ }),

/***/ 63:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({

  components: {},
  name: 'Footer',
  methods: {

    getFullYear: function getFullYear() {
      var today = new Date();
      return today.getFullYear();
    }

  },
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 64:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__(25);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* https://alligator.io/vuejs/global-event-bus/ */


/* harmony default export */ __webpack_exports__["default"] = ({

  mounted: function mounted() {

    $(".sidebar-toggle").click(function (e) {
      e.preventDefault();
      $("#wrapper").toggleClass("toggled");
    });

    $('a.icjiaTypography').webuiPopover({ width: 900, height: 500, type: 'iframe', url: 'http://www.icjia.state.il.us/sandbox/typography' });

    $(document).ready(function () {
      $(".dropdown-menu a").click(function () {
        $(this).closest(".dropdown-menu").prev().dropdown("toggle");
      });
    });
  },

  methods: {
    loadBoilerplateEvent: function loadBoilerplateEvent(bp) {
      __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* EventBus */].$emit('load-boilerplate', bp);
    },


    startTutorial: function startTutorial() {
      introJs().start();
    }
  }
});

/***/ }),

/***/ 65:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),

/***/ 66:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__boilerplates__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_bus__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__templates_default__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var md = __webpack_require__(136)({
    html: true,
    linkify: true,
    typographer: true
});
md.use(__webpack_require__(130));
md.use(__webpack_require__(129));
md.use(__webpack_require__(127));
md.use(__webpack_require__(131));
// md.use(require("markdown-it-github-headings"))
md.use(__webpack_require__(132));








var removeMd = __webpack_require__(188);
var beautify_html = __webpack_require__(108).html;
var lil = __webpack_require__(123);
var FileSaver = __webpack_require__(105);

function syncScroll(el1, el2) {
    var $el1 = $(el1);
    var $el2 = $(el2);

    // Lets us know when a scroll is organic
    // or forced from the synced element.
    var forcedScroll = false;

    // Catch our elements' scroll events and
    // syncronize the related element.
    $el1.scroll(function () {
        performScroll($el1, $el2);
    });
    $el2.scroll(function () {
        performScroll($el2, $el1);
    });

    // Perform the scroll of the synced element
    // based on the scrolled element.
    function performScroll($scrolled, $toScroll) {
        if (forcedScroll) return forcedScroll = false;
        var percent = $scrolled.scrollTop() / ($scrolled[0].scrollHeight - $scrolled.outerHeight()) * 100;
        setScrollTopFromPercent($toScroll, percent);
    }

    // Scroll to a position in the given
    // element based on a percent.
    function setScrollTopFromPercent($el, percent) {
        var scrollTopPos = percent / 100 * ($el[0].scrollHeight - $el.outerHeight());
        forcedScroll = true;
        $el.scrollTop(scrollTopPos);
    }
}

// function download(filename, text, ext) {
//     var pom = document.createElement('a');
//     pom.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
//     pom.setAttribute('download', filename + ext);
//
//     if (document.createEvent) {
//         var event = document.createEvent('MouseEvents');
//         event.initEvent('click', true, true);
//         pom.dispatchEvent(event);
//     } else {
//         pom.click();
//     }
// }


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            myInput: '',
            fileTitle: '',
            selected: '',
            localStorage: false,

            linkData: '',
            errors: [],
            apiBase: '',
            responseData: '',
            test: '',
            siteBase: '',
            copyData: ''

        };
    },

    name: 'Home',
    props: {
        plink: {
            type: String,
            default: ''
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.loadLocalStorage();

        // Event bus
        __WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* EventBus */].$on('load-boilerplate', function (bp) {
            console.log('Load boilerplate: ' + bp);
            //$('#status').html('Load boilerplate: ' + bp)
            //console.log(boilerplateMap[0]["selectName"])
            var myObj = _.find(__WEBPACK_IMPORTED_MODULE_1__boilerplates__["a" /* boilerplateMap */], ['selectName', bp]);
            _this.myInput = myObj["body"];
        });

        __WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* EventBus */].$on('load-markdown', function (md) {
            console.log('Load markdown: ' + md);
            vm.myInput = md;
        });

        var vm = this;

        // if (typeof localStorage !== 'undefined') {
        //     this.localStorage=true;
        // } else {
        //     this.localStorage=false;
        // }

        $('a.pop').webuiPopover();

        $(document).ready(function () {

            syncScroll($('.markdown-body '), $('#markdown'));

            // Load default document in local storage if it exists.

            if (vm.link === '') {
                if (localStorage.getItem("mdTemp") === null) {
                    vm.myInput = __WEBPACK_IMPORTED_MODULE_1__boilerplates__["a" /* boilerplateMap */][0].body;
                } else {
                    vm.myInput = localStorage.getItem('mdTemp');
                }
            }
        });

        // set default title
        var myFileTile = __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('DD-MM-YYYY').replace(/\s+/g, '');
        vm.fileTitle = 'saveFile' + myFileTile;

        $(document).keydown(function (event) {
            // If Control or Command key is pressed and the S key is pressed
            // run save function. 83 is the key code for S.


            if ((event.ctrlKey || event.metaKey) && event.which == 83) {
                // Ctrl-S saves to local storage.
                var myMd = $('#markdown').val();
                localStorage.setItem('mdTemp', myMd);
                //$('#status').html('Saved: local storage')
                //vm.updateStatus("STATUS", "Saved to local storage.")
                event.preventDefault();
                return false;
            };

            // https://css-tricks.com/snippets/javascript/javascript-keycodes/
            if ((event.ctrlKey || event.metaKey) && event.which == 76) {
                // Ctrl-L loads from local storage
                var _myMd = localStorage.getItem('mdTemp');
                vm.$emit('loadFile', _myMd);

                event.preventDefault();
                return false;
            };
        });

        window.setInterval(function () {
            var time = new Date();
            //console.log(time.getHours() + ":" + time.getMinutes() + ":" + time.getSeconds());
            var myMd = $('#markdown').val();
            //console.log(myMd)
            localStorage.setItem('mdTemp', myMd);
            var message = 'Auto saved to local storage: ' + __WEBPACK_IMPORTED_MODULE_0_moment___default()().format("h:mm:ss a");
            //$('#auto-save').html(message)
            console.log(message);
        }, 15000);
    },
    methods: {
        // saveExperimental: function () {
        //   var blob = new Blob([this.myInput], {type: "text/plain;charset=utf-8"});
        //   FileSaver.saveAs(blob, "Markdown.md");
        // },
        downloadFile: function downloadFile(filename, text, ext) {
            var blob = new Blob([text], { type: "text/plain;charset=utf-8" });
            FileSaver.saveAs(blob, filename + ext);
        },
        showHTML: function showHTML() {
            this.updateStatus("", "Show Raw HTML");
            var results = '<pre><xmp>' + beautify_html($('.markdown-body ').html()) + '</xmp></pre>';
            var options = {
                message: results,
                title: 'HTML',
                size: eModal.size.xl
            };
            eModal.alert(options);
            //console.log($('.markdown-body ').html())
        },

        areaChange: function areaChange() {
            console.log('Change');
        },
        updateMd: function updateMd() {
            this.myInput = 'loaded';
        },
        clear: function clear() {
            this.myInput = '';
            this.selected = '';
            this.updateStatus("", "Markdown cleared");
        },

        update: function update() {
            _.debounce(function (e) {
                this.myInput = e.target.value;
            }, 300);
        },
        saveMd: function saveMd() {
            this.downloadFile(this.fileTitle, this.myInput, '.md');
            this.updateStatus("STATUS", "Saved markdown file.");
        },

        reRender: function reRender() {
            console.log('reRender');
        },

        loadMd: function loadMd(e) {
            var vm = this;
            var fileInput = document.getElementById('fileInput');
            var markdownDiv = document.getElementById('markdown');
            var file = fileInput.files[0];
            vm.fileTitle = file.name;
            vm.fileTitle = vm.fileTitle.replace(/\.[^/.]+$/, "");
            //console.log('Filename: ', vm.fileTitle)

            this.updateStatus("", "Load external file.");
            // set context

            // need to implement file-type check here
            if (true) {
                var reader = new FileReader();
                //Filereader: https://developer.mozilla.org/en-US/docs/Web/API/FileReader
                reader.onload = function (e) {

                    __WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* EventBus */].$emit('load-markdown', reader.result);
                };
                reader.readAsText(file);
            } else {
                fileDisplayArea.innerText = "File not supported!";
            }
        },
        saveRawHtml: function saveRawHtml() {

            //console.log('Save html:')
            //console.log($('.markdown-body ').html())

            this.downloadFile(this.fileTitle, beautify_html($('.markdown-body ').html()), '.html');
            this.updateStatus("", "Saved raw HTML.");
        },
        saveStyledHtml: function saveStyledHtml() {
            //$('#status').html('Saved to styled html')
            //console.log('Save html:')
            //console.log($('.markdown-body ').html())
            var myHTML = $('.markdown-body ').html();
            // let styledHTML = `<html><head></head><body>${myHtml}</body></html>`
            //console.log(defaultTemplate(myHTML))
            this.downloadFile(this.fileTitle, beautify_html(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__templates_default__["a" /* defaultTemplate */])(myHTML)), '.html');
            this.updateStatus("", "Saved styled HTML.");
        },
        saveTxt: function saveTxt() {

            var plainText = removeMd(this.myInput);
            //console.log(plainText)
            this.downloadFile(this.fileTitle, plainText, '.txt');
            this.updateStatus("", "Saved plain text.");
        },
        saveLocalStorage: function saveLocalStorage() {
            localStorage.setItem('mdTemp', this.myInput);
            //console.log(this.myInput)
            this.updateStatus("", "Saved to local storage.");
        },
        changeSelect: function changeSelect() {
            $('#status').html('Load boilerplate: ' + this.selected);
            //console.log(boilerplateMap[0]["selectName"])
            var myObj = _.find(__WEBPACK_IMPORTED_MODULE_1__boilerplates__["a" /* boilerplateMap */], ['selectName', this.selected]);
            this.myInput = myObj["body"];
        },
        loadLocalStorage: function loadLocalStorage() {

            var content = localStorage.getItem('mdTemp');
            //console.log(content)
            this.myInput = content;
        },

        updateStatus: function updateStatus(title, body) {
            var t = '<span style="margin-bottom: 15px; text-transform: uppercase"><b>' + title + '</b></span>&nbsp;&nbsp;';
            var b = body;
            $('.status').show();
            $('.status-text').html(t + b);
            setTimeout(function () {
                $('.status').hide();
                $('.status-text').html('');
            }, 3000);
        },

        clearStatus: function clearStatus() {
            $('.status').hide();
        }

    },

    computed: {
        compiledMarkdown: function compiledMarkdown() {
            return md.render(this.myInput);
        }
    }
});

/***/ }),

/***/ 67:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return article01; });
var article01 = "## Reducing Substance Use Disorders and Related Offending: A Continuum of Evidence-Informed Practices in the Criminal Justice System\n\nIn the United States, more than 20 million individuals have substance use disorders (SUDs)\u2014not including individuals with more mild or moderate substance use and misuse.[^1]  Of those with SUDs, just over 10 percent ultimately receive treatment.[^2]  On average, costs incurred in the United States from alcohol and drug use due to lost work productivity, health care expenses, motor vehicle accidents, and criminal justice costs exceeds $400 billion. Almost half of the cost is at the taxpayers\u2019 expense.[^3]\n\nOf the 20 million individuals with SUDs, a subset is involved with the criminal justice system. More than half of the 2.2 million individuals housed in U.S. prisons and jails meet the clinical diagnosis criteria for SUDs.[^4]  Seventy-eight percent of violent crimes and 77 percent of property crimes involve drugs and/or alcohol.[^5]  The government spends an estimated $74 billion dollars on court processing, community supervision, and imprisonment of individuals with SUDs, but just 1 percent of that amount on prevention and treatment for these individuals.[^6]  In addition, about 11 percent of prisoners with SUDs or substance misuse receive treatment.[^7]\n\nToday, SUDs and substance misuse and abuse are considered a [public health issue](https://addiction.surgeongeneral.gov/surgeon-generals-report.pdf), as well as a criminal justice concern. Public health, treatment providers, medical, and criminal justice professionals, as well as community members, legislators, and other stakeholders, are encouraged to collaborate to develop a comprehensive approach to SUDs.[^8]  Together, they can increase access to substance use, misuse, and SUD treatment and the use of harm reduction tactics to reduce substance use, overdose, and criminal justice involvement.[^9]\n\nA multipronged approach to addressing drug availability and use in Illinois communities entail interdiction efforts aimed at those who traffic large quantities of illicit substances, as well as prevention, deflection, diversion, and treatment of those who use. Traditional law enforcement tactics work to combat traffickers and suppliers to reduce influx of drugs in the community.[^10]  At the same time, the system can offer diversion, outreach, and referrals to treatment services.\n\nSeveral substance use treatment models are effective, some more so than others.[^11]  Over the past several decades, research and rigorous evaluation has provided insight on effective practices for individuals with SUDs and other substance use issues and the importance of treatment over criminal justice system involvement.[^12]  By integrating [evidence-informed practices](http://www.jrsa.org/projects/ebp_briefing_paper_april2014.pdf), criminal justice agencies and communities can save lives, decrease costs to the criminal justice system, healthcare systems, and taxpayers.[^13]\n\nICJIA researchers developed this continuum to share evidence-informed practices for addressing SUDs and substance misuse to guide local-level assessment, planning, and implementation efforts around SUD prevention and intervention. These practices range from early prevention to services to support successful reintegration back into the community following time spent in jail or prison. Communities are encouraged to use this continuum to examine the gaps and needs that exist in their areas and explore the options available to address those gaps.\n\n\n\n----------\n\n\n### Evidence-Based Risk and Protective Factors\n\nPrevention of substance use requires an understanding of factors that may decrease the potential for substance use (protective factors) and factors that may put individuals at risk, or increase potential for substance use (risk factors). Evidence-informed prevention programs can target risk factors and enhance protective factors.[^15]  There are five, evidence-based ecological domains that have been shown to be the most predictive of delinquency, including substance use: individual, family, peer, school, and community.\n\n### Risk factors include:[^16]\n#### Individual/Peer\n\n - Early initiation of substance use.\n - Persistent and early problem behavior.*\n - Rebelliousness.\n - Favorable attitudes toward substance use.\n - Peer substance use\n - Genetic susceptibility to substance use.\n\n#### Family\n\n - Poor family management skills (expectations, supervision, monitoring, inappropriate punishment).\n - Family conflict.\n - Parental attitudes favorable toward substance use.\n - Family history of substance misuse.\n\n#### School\n\n - Late elementary school academic failure.\n - Lack of commitment to school.\n\n\n#### Community\n\n - Low cost of alcohol.\n - High availability of substances.\n - Community laws/norms favorable toward substance use.\n - Media portrayal of alcohol use.*\n - Low level of neighborhood bonding/attachment.*\n - Community disorganization (e.g. high population density, physical deterioration, high rates of adult crime).*\n - Low socioeconomic status.*\n - High rates of mobility within or between communities.*\n\n\n### Protective factors include:[^17]\n#### Individual/peer\n\n - Social, emotional, behavioral, cognitive, and moral competence; interpersonal skills.\n - Self-efficacy.\n - Spirituality.\n - Resiliency.\n\n#### Family, school, and community\n\n - Opportunities for positive social involvement.\n - Recognition for positive behavior (reinforcements).\n - Bonding (attachment or commitment).\n - Healthy beliefs and standards for behavior.\n - Marriage or committed relationship.**\n######*denotes factor related to adolescent substance use.\n######*denotes factor related to young adult substance use.\n\n\n[^1]: U.S. Department of Health and Human Services (HHS), Office of the Surgeon General. (2016). *Facing addiction in America: The Surgeon General\u2019s report on alcohol, drugs, and health.* Washington, DC: HHS.\n\n[^2]: U.S. Department of Health and Human Services (HHS), Office of the Surgeon General. (2016). *Facing addiction in America: The Surgeon General\u2019s report on alcohol, drugs, and health.* Washington, DC: HHS.\n\n[^3]:U.S. Department of Health and Human Services (HHS), Office of the Surgeon General. (2016). *Facing addiction in America: The Surgeon General\u2019s report on alcohol, drugs, and health.* Washington, DC: HHS.\n\n[^4]:The National Center on Addiction and Substance Abuse. (2010). *Behind bars II: Substance abuse and America\u2019s prison population.* Columbia, NY: Columbia University.; Caulkins, J. P., & Kleiman, M. A. R. (2014). *How much crime is drug-related? History, limitations, and potential improvements of estimation methods.* Washington, DC: U.S. Department of Justice.\n\n[^5]: Centers for Disease Control and Prevention. (2016). Understanding the epidemic. Last modified June 21, 2016. Retrieved from http://bit.ly/2oqfbEf.\n\n[^6]:The National Center on Addiction and Substance Abuse. (2010). *Behind bars II: Substance abuse and America\u2019s prison population.* Columbia, NY: Columbia University.\n\n[^7]:The National Center on Addiction and Substance Abuse. (2010). *Behind bars II: Substance abuse and America\u2019s prison population.* Columbia, NY: Columbia University.\n\n[^8]: Pelan, M. (2015). Re-visioning drug use: A shift away from criminal justice and abstinence-based approaches. *Social Work and Society International Online Journal*, *13*(2).\n\n[^9]: Harm Reduction Coalition. (n.d.). *Principles of harm reduction*. Retrieved from http://bit.ly/1I4t27D.\n\n[^10]:Reichert, J., Sacomani, R., Medina, E., DeSalvo, M., & Adams, S. (2016). *Drug trends and distribution in Illinois: A survey of drug task forces.* Chicago, IL: Illinois Criminal Justice Information Authority.\n\n[^11]: Bahr, S. J., Masters, A. L., & Taylor, B. M. (2012). What works in substance abuse treatment programs for offenders? *The Prison Journal, 92*(2), 155-174.; Police Executive Research Forum. (2016). Building successful partnerships between law enforcement and public health agencies to address opioid use. *COPS Office Emerging Issues Forums.* Washington, DC: Office of Community Oriented Policing Services.\n\n[^12]:Chandler, R. K., Fletcher, B. W., & Volkow, N. D. (2014). Treatment drug abuse and addiction in the criminal justice system: Improving public health and safety. *Journal of the American Medical Association, 30*(12), 183-190.\n\n[^13]:Office of National Drug Control Policy. (2012). *Costs and benefits of investing early in substance abuse treatment.* Executive Office of the President. Washington, D.C.\n\n[^14]: Crimesolutions.gov. (2011). *Glossary.* National Institute of Justice, Office of Justice Programs. Washington,\nDC Retrieved from http://bit.ly/2oieUTg.; Blueprints Program Model. (2012-2016). *Program criteria.* Blueprints for Healthy Youth Development. Boulder, CO. Retrieved from http://bit.ly/2oFVhqG.; see also Orchowsky, S. (2014). *An introduction to evidence-based practices.* Washington, DC: Justice Research and Statistics Association, Bureau of Justice Assistance, U.S. Department of Justice, and National Criminal Justice Association.\n\n[^15]: U.S. Department of Health and Human Services (HHS), Office of the Surgeon General. (2016). *Facing addiction in America: The Surgeon General\u2019s report on alcohol, drugs, and health.* Washington, DC: Author.; see also Catalano, R. F., Fagan, A. A., Gavin, L. E., Greenberg, M. T., Irwin, C. E., Ross, D. A., & Shek, D. T. (2012). Worldwide application of prevention science in adolescent health. *The Lancet, 379*(9826), 1653-1664.; Stone, A. L., Becker, L. G., Huber, A. M., & Catalano, R. F. (2012). Review of risk and protective factors of substance use and problem use in emerging adulthood. *Addictive Behaviors, 37*(7), 747- 775.; Shek, D. T. L., Sun, R. C. F., & Merrick, J. (2012). Positive youth development constructs: Conceptual review and application. *The Scientific World Journal*.; Viner, R. M., Ozer, E. M., Denny, S., Marmot, M., Resnick, M., Fatusi, A., & Currie, C. (2012). Adolescence and the social determinants of health. *The Lancet, 379*(9826), 1641-1652.\n\n[^16]: U.S. Department of Health and Human Services (HHS), Office of the Surgeon General. (2016). *Facing addiction in America: The Surgeon General\u2019s report on alcohol, drugs, and health.* Washington, DC: Author.\n\n[^17]: U.S. Department of Health and Human Services (HHS), Office of the Surgeon General. (2016). *Facing addiction in America: The Surgeon General\u2019s report on alcohol, drugs, and health.* Washington, DC: Author.\n\n[^18]:U.S. Department of Health and Human Services (HHS), Office of the Surgeon General. (2016). *Facing addiction in America: The Surgeon General\u2019s report on alcohol, drugs, and health.* Washington, DC: Author.\n\n\n";


/***/ }),

/***/ 68:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return boilerplate01; });
var boilerplate01 = "# We respect your privacy\u200B\n\nThis is the web site of ***AGENCY NAME***\n\nOur postal address:\n\n***AGENCY NAME***\n\n*STREET ADDRESS 1*\n\n*STREET ADDRESS 2*\n\n*CITY, STATE ZIP*\n\n\nOur phone number:\n\n*PHONE NUMBER*\n\nWe can also be reached via e-mail at the ICJIA's Information Clearinghouse:\n\n[EMAIL_ADDRESS](mailto:EMAIL_ADDRESS)\n\nQuestions about the website should be directed to:\n\n[CONTACT_NAME](mailto:CONTACT_NAME)\n\nFor each visitor to our Web page, our Web server automatically recognizes the visitor's IP address.\n\nWe collect the domain name of users to our Web page, the e-mail addresses of those who communicate with us via e-mail, and aggregate information on what pages visitors access or visit and information volunteered by the visitor -- such as survey information and/or site registrations.\n\nThe information we collect is used to improve our web content and services. If you want to receive e-mail from us in the future, please let us know by sending email to us at the above address or writing to us at the above address and telling us that you want to receive e-mail from our agency.\n\nPersons who supply us with their telephone numbers on-line may receive telephone contact from us with information regarding orders they have placed on-line.";


/***/ }),

/***/ 69:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return boilerplate02; });
var boilerplate02 = "# This is Boilerplate 02\n\nTest one two three four.\n\n*test italics*\n\n";


/***/ }),

/***/ 70:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return boilerplate03; });
var boilerplate03 = "# H1 HEADER\n\n\nParagraphs are separated by a blank line.\n\n2nd paragraph. *Italic*, **bold**, and `monospace`. Itemized lists\nlook like:\n\n  * this one\n  * that one\n  * the other one\n\nNote that --- not considering the asterisk --- the actual text\ncontent starts at 4-columns in.\n\n> Block quotes are\n> written like so.\n>\n> They can span multiple paragraphs,\n> if you like.\n\nUse 3 dashes for an em-dash. Use 2 dashes for ranges (ex., \"it's all\nin chapters 12--14\"). Three dots ... will be converted to an ellipsis.\nUnicode is supported. \u263A\n\n----\n\n## H2 HEADER\n### H3 HEADER\n#### h4 HEADER\n\nHere's a numbered list:\n\n 1. first item\n 2. second item\n 3. third item\n\nNote again how the actual text starts at 4 columns in (4 characters\nfrom the left side). Here's a code sample:\n\n    # Let me re-iterate ...\n    for i in 1 .. 10 { do-something(i) }\n\nAs you probably guessed, indented 4 spaces. By the way, instead of\nindenting the block, you can use delimited blocks, if you like:\n\n~~~\ndefine foobar() {\n    print \"Welcome to flavor country!\";\n}\n~~~\n\n(which makes copying & pasting easier). You can optionally mark the\ndelimited block for Pandoc to syntax highlight it:\n\n~~~python\nimport time\n# Quick, count to ten!\nfor i in range(10):\n    # (but not *too* quick)\n    time.sleep(0.5)\n    print i\n~~~\n\n----\n\n### H3 HEADER\n\nNow a nested list:\n\n 1. First, get these ingredients:\n\n      * carrots\n      * celery\n      * lentils\n\n 2. Boil some water.\n\n 3. Dump everything in the pot and follow\n    this algorithm:\n\n        find wooden spoon\n        uncover pot\n        stir\n        cover pot\n        balance wooden spoon precariously on pot handle\n        wait 10 minutes\n        goto first step (or shut off burner when done)\n\n    Do not bump wooden spoon or it will fall.\n\nNotice again how text always lines up on 4-space indents (including\nthat last line which continues item 3 above).\n\nHere's a link to [a website](http://foo.bar), to a [local\ndoc](local-doc.html), and to a [section heading in the current\ndoc](#an-h2-header). Here's a footnote [^1].\n\n[^1]: Footnote text goes here.\n\n***\n\nand images can be specified like so:\n\n![example image](https://avatars0.githubusercontent.com/u/6942692?v=3&s=260 )\n\nAnd note that you can backslash-escape any punctuation characters\nwhich you wish to be displayed literally, ex.: `foo`, *bar*, etc.\n\n\n### Tables\n\n**Markdown Extra** has a special syntax for tables:\n\nItem     | Value\n-------- | ---\nComputer | $1600\nPhone    | $12\nPipe     | $1\n\nYou can specify column alignment with one or two colons:\n\n| Item     | Value | Qty   |\n| :------- | ----: | :---: |\n| Computer | $1600 |  5    |\n| Phone    | $12   |  12   |\n| Pipe     | $1    |  234  |";


/***/ }),

/***/ 71:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return boilerplate04; });
var boilerplate04 = "# Footnotes\n\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Cras eget turpis nec justo volutpat efficitur. Sed ac sapien in magna faucibus faucibus eu sed nisl. Aenean non tristique odio, eu condimentum nisl. Suspendisse porttitor ante id lectus pharetra, id pretium odio lacinia. Vestibulum auctor volutpat pharetra. Nam rhoncus dapibus enim eget ornare.[^1] Phasellus convallis nisi a efficitur iaculis.[^2] Etiam tempus massa diam, sit amet lacinia metus suscipit sit amet. Nunc consequat ligula ac auctor mollis. Integer accumsan ornare neque, id dapibus elit. Ut accumsan lacinia metus nec luctus.[^3]\n\n\n[^1]: Here is the footnote.\n\n[^2]: Here is the second footnote.\n\n[^3]: Here's one with multiple blocks.\n\n    Subsequent paragraphs are indented to show that they\nbelong to the previous footnote.\n\n\n\n";


/***/ }),

/***/ 72:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return expandable; });
var expandable = "# Expandable details\n\n<p>\n<details><summary>React / Preact</summary><br>\n\n```js\nimport React from 'react'\nimport { render } from 'react-dom'\n\nconst App = () => <h1>Hello React.</h1>\n\nrender(<App />, document.getElementById('app'))\n```\n\nNote: You need to install `react` `react-dom` and desired babel preset like `babel-preset-react-app`. For convenience, here's also [poi-preset-react](https://github.com/egoist/poi/tree/master/packages/poi-preset-react) you can use.\n\nIt's similar for other React-like framework.\n</details>\n\n<details><summary>Vue</summary><br>\n\n```js\nimport Vue from 'vue'\n\nnew Vue({\n  el: '#app',\n  render() {\n    return <h1>Hello Vue.</h1>\n  }\n})\n```\n\nNote: You don't need to install any dependencies, `vue` is already brought by `Poi`. And single-file component is also supported by default.\n</details>\n\n## FAQ\n\n<details><summary>How's it different from a boilerplate?</summary><br>\n\nIt's hard to upgrade your project if you're using a boilerplate since you might change the code to suit your needs. However you can easily upgrade your project to use latest version of Poi by simply updating the dependency.\n\nYou can also get rid of boilerplate code in this way.\n</details>";



/***/ }),

/***/ 73:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fontawesome; });
var fontawesome = "# Fontawesome icons\n\nHello World! :fa-camera:\n\n- [:fa-google: Google](https://www.google.com/)\n- [:fa-github: GitHub](https://github.com/)\n\nSee: [http://fontawesome.io/](http://fontawesome.io/) for more icons.\n";


/***/ }),

/***/ 74:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return icjiaTypography; });
var icjiaTypography = "\n# Heading 1 (#)\n## Heading 2 (##)\n### Heading 3 (###)\n#### Heading 4 (####)\n##### Heading 5 (#####)\n###### Heading 6 (######)\n\n---\n\n<div style=\"text-align: center\">\n\n#### DEFAULT TABLE HEADING (####)\n\n</div>\n\n| Item     | Value | Qty   |\n| :------- | ----: | :---: |\n| Computer | $1600 |  5    |\n| Phone    | $12   |  12   |\n| Pipe     | $1    |  234  |\n\n---\n\n<div style=\"text-align: center\">\n\n#### DEFAULT CHART HEADING (####)\n\n</div>\n\n\n![Sample Chart](/static/img/sampleChart.png)\n\n---\n# Sample article title (#)\n\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam tristique orci a metus scelerisque dapibus a eu enim. Nam ipsum urna, convallis in rutrum a, porta at nulla. Nunc at eros in neque euismod elementum. Curabitur dictum eget nulla non cursus. Suspendisse tempus metus erat, id pharetra ligula bibendum ac. Nunc eleifend consectetur nulla, vel iaculis libero scelerisque ac. Maecenas venenatis rutrum erat, nec volutpat risus efficitur et.\n\n## Sub-heading (##)\n\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam tristique orci a metus scelerisque dapibus a eu enim. Nam ipsum urna, convallis in rutrum a, porta at nulla. Nunc at eros in neque euismod elementum. Curabitur dictum eget nulla non cursus. Suspendisse tempus metus erat, id pharetra ligula bibendum ac. Nunc eleifend consectetur nulla, vel iaculis libero scelerisque ac. Maecenas venenatis rutrum erat, nec volutpat risus efficitur et.\n\n### Sub-sub-heading 1 (###)\n\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam tristique orci a metus scelerisque dapibus a eu enim. Nam ipsum urna, convallis in rutrum a, porta at nulla.\n\n### Sub-sub-heading 2 (###)\n\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam tristique orci a metus scelerisque dapibus a eu enim. Nam ipsum urna, convallis in rutrum a, porta at nulla.\n\n### Sub-sub-heading 3 (###)\n\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam tristique orci a metus scelerisque dapibus a eu enim. Nam ipsum urna, convallis in rutrum a, porta at nulla.\n\n## Sub-heading (##)\n\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam tristique orci a metus scelerisque dapibus a eu enim. Nam ipsum urna, convallis in rutrum a, porta at nulla. Nunc at eros in neque euismod elementum. Curabitur dictum eget nulla non cursus. Suspendisse tempus metus erat, id pharetra ligula bibendum ac. Nunc eleifend consectetur nulla, vel iaculis libero scelerisque ac. Maecenas venenatis rutrum erat, nec volutpat risus efficitur et.\n\n\n\n\n\n\n\n\n\n\n";


/***/ }),

/***/ 75:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return images; });
var images = "# Embedding Images\n\n\n#### Cloning the repo to local machine:\n\n![link to build](https://github.com/ICJIA/icjia-simple-webpack-example//raw/master/howto/clone.gif)\n\n#### Running first time install ```npm install```:\n\n![link to build](https://github.com/ICJIA/icjia-simple-webpack-example//raw/master/howto/install1.gif)\n\n#### Running development server ```npm run dev```:\n\n![link to build](https://github.com/ICJIA/icjia-simple-webpack-example//raw/master/howto/dev.gif)\n\n#### Running build process ```npm run build```:\n\n![link to build](https://github.com/ICJIA/icjia-simple-webpack-example//raw/master/howto/build.gif)\n\n## Screen capture\n- [Giphy](http://giphy.com/)\n";



/***/ }),

/***/ 76:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return boilerplateMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__welcome__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__boilerplate01__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__boilerplate02__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__boilerplate03__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__boilerplate04__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toc__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fontawesome__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tables__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__math__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__readme__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__article01__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pagetop__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixed__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__expandable__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icjiaTypography__ = __webpack_require__(74);

















var boilerplateMap = [{
    title: 'Welcome',
    body: __WEBPACK_IMPORTED_MODULE_0__welcome__["a" /* welcome */],
    selectName: 'What is Markdown?'
}, {
    title: 'Boilerplate 01',
    body: __WEBPACK_IMPORTED_MODULE_1__boilerplate01__["a" /* boilerplate01 */],
    selectName: 'Privacy 01'
}, {

    title: 'Boilerplate 02',
    body: __WEBPACK_IMPORTED_MODULE_2__boilerplate02__["a" /* boilerplate02 */],
    selectName: 'Privacy 02'
}, {

    title: 'Boilerplate 03',
    body: __WEBPACK_IMPORTED_MODULE_3__boilerplate03__["a" /* boilerplate03 */],
    selectName: 'Getting Started'
}, {

    title: 'Boilerplate 04',
    body: __WEBPACK_IMPORTED_MODULE_4__boilerplate04__["a" /* boilerplate04 */],
    selectName: 'Footnotes'
}, {

    title: 'Fontawesome',
    body: __WEBPACK_IMPORTED_MODULE_6__fontawesome__["a" /* fontawesome */],
    selectName: 'Fontawesome icons'
}, {

    title: 'Tables',
    body: __WEBPACK_IMPORTED_MODULE_7__tables__["a" /* tables */],
    selectName: 'Tables'
}, {

    title: 'Math',
    body: __WEBPACK_IMPORTED_MODULE_8__math__["a" /* math */],
    selectName: 'Math (using KaTeX)'
}, {
    title: 'GitHub Readme',
    body: __WEBPACK_IMPORTED_MODULE_9__readme__["a" /* readme */],
    selectName: 'GitHub README'
}, {
    title: 'Article 01',
    body: __WEBPACK_IMPORTED_MODULE_10__article01__["a" /* article01 */],
    selectName: 'Article 01'
}, {
    title: 'Images',
    body: __WEBPACK_IMPORTED_MODULE_11__images__["a" /* images */],
    selectName: 'Images'
}, {
    title: 'Page top',
    body: __WEBPACK_IMPORTED_MODULE_12__pagetop__["a" /* pagetop */],
    selectName: 'Return to page top'
}, {
    title: 'Mixed',
    body: __WEBPACK_IMPORTED_MODULE_13__mixed__["a" /* mixed */],
    selectName: 'Mixed HTML and Markdown'
}, {
    title: 'Expandable details',
    body: __WEBPACK_IMPORTED_MODULE_14__expandable__["a" /* expandable */],
    selectName: 'Expandable details'
}, {
    title: 'ICJIA Typography',
    body: __WEBPACK_IMPORTED_MODULE_15__icjiaTypography__["a" /* icjiaTypography */],
    selectName: 'ICJIA Style Guide'
}];



/***/ }),

/***/ 77:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return math; });
var math = "# Math (using KaTeX)\n\n$\\sqrt{3x-1}+(1+x)^2$\n\n#### For more information, please see:\n\n[https://github.com/waylonflinn/markdown-it-katex](https://github.com/waylonflinn/markdown-it-katex)\n\n#### Demo:\n\n[http://waylonflinn.github.io/markdown-it-katex/](http://waylonflinn.github.io/markdown-it-katex/)\n\n";


/***/ }),

/***/ 78:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mixed; });
var mixed = "<div align=\"center\">\n<a id=\"top \"></a>\n<h1>\n    <img alt=\"MARKDOWN SYNTAX\" src=\"https://cloud.githubusercontent.com/assets/5456665/13505154/0ca9ddf6-e1a2-11e5-9408-a8cfc6b493f0.png\" width=\"350\" height=\"70\"></img>\n</h1>\n\n\n</div>\n\n<br/><br/>\n\n### HEADER\n\n    # Header1\n    ## Header2\n    ### Header3\n    #### Header4\n    ##### Header5\n    ###### Header6\n    H1\n    ===\n    H2\n    ---\n\n# Header1\n## Header2\n### Header3\n#### Header4\n##### Header5\n###### Header6\nH1\n===\nH2\n---\n\n<br/>\n<div align=\"right\">\n    <b><a href=\"#top \">\u21A5 back to top</a></b>\n</div>\n<br/>\n\n### EMPHASIS\n\n    *Italic1* _Italic2_\n    **Bold1** __Bold2__\n    ***Bold_Italic***\n    ~~Strikethrough~~\n\n*Italic1* _Italic2_ </br>\n**Bold1** __Bold2__ </br>\n***Bold_Italic*** </br>\n~~Strikethrough~~\n\n<br/>\n<div align=\"right\">\n    <b><a href=\"#top \">\u21A5 back to top</a></b>\n</div>\n<br/>\n\n### HORIZONTAL LINE\n\n    ---\n    ***\n    ___\n\n---\n***\n___\n\n<br/>\n<div align=\"right\">\n    <b><a href=\"#top \">\u21A5 back to top</a></b>\n</div>\n<br/>\n\n### LIST\n\n    unordered list:\n\n    * item-1\n      * sub-item-1\n      * sub-item-2\n    - item-2\n      - sub-item-3\n      - sub-item-4\n    + item-3\n      + sub-item-5\n      + sub-item-6\n\n\n    ordered list:\n\n    1. item-1\n     1. sub-item-1\n     2. sub-item-2\n    2. item-2\n     1. sub-item-3\n     2. sub-item-4\n    3. item-3\n\nunordered list:\n\n* item-1\n  * sub-item-1\n  * sub-item-2\n- item-2\n  - sub-item-3\n  - sub-item-4\n+ item-3\n  + sub-item-5\n  + sub-item-6\n\nordered list:\n\n1. item-1\n 1. sub-item-1\n 2. sub-item-2\n2. item-2\n 1. sub-item-3\n 2. sub-item-4\n3. item-3\n\n<br/>\n<div align=\"right\">\n    <b><a href=\"#top \">\u21A5 back to top</a></b>\n</div>\n<br/>\n\n### TABLE\n\n```\nTable Header-1 | Table Header-2 | Table Header-3\n:--- | :---: | ---:\nTable Data-1 | Table Data-2 | Table Data-3\nTD-4 | Td-5 | TD-6\nTable Data-7 | Table Data-8 | Table Data-9\n```\n\nTable Header-1 | Table Header-2 | Table Header-3\n:--- | :---: | ---:\nTable Data-1 | Table Data-2 | Table Data-3\nTD-4 | Td-5 | TD-6\nTable Data-7 | Table Data-8 | Table Data-9\n\n<br/>\n<div align=\"right\">\n    <b><a href=\"#top \">\u21A5 back to top</a></b>\n</div>\n<br/>\n\n### LINK\n\n    https://github.com/MinhasKamal/github-markdown-syntax\n    [GitHub](https://github.com/MinhasKamal/github-markdown-syntax)\n    [click](https://github.com/MinhasKamal/github-markdown-syntax \"GitHub Markdown Syntax\")\n    [README](/README.md)\n    [Image](#image)\n\nhttps://github.com/MinhasKamal/github-markdown-syntax\n[GitHub](https://github.com/MinhasKamal/github-markdown-syntax)\n[click](https://github.com/MinhasKamal/github-markdown-syntax \"GitHub Markdown Syntax\")\n[README](/README.md)\n[Image](#image)\n\n<br/>\n<div align=\"right\">\n    <b><a href=\"#top \">\u21A5 back to top</a></b>\n</div>\n<br/>\n\n### IMAGE\n\n    ![GitHub Logo](https://cloud.githubusercontent.com/assets/5456665/13322882/e74f6626-dc00-11e5-921d-f6d024a01eaa.png \"GitHub\")\n\n![GitHub Logo](https://cloud.githubusercontent.com/assets/5456665/13322882/e74f6626-dc00-11e5-921d-f6d024a01eaa.png \"GitHub\")\n\n<br/>\n<div align=\"right\">\n    <b><a href=\"#top \">\u21A5 back to top</a></b>\n</div>\n<br/>\n\n### QUOTE\n\n    > Stay hungry; stay foolish.\n    >> Quality is better than quantity.\n    >>> Life is not fair; get used to it.\n\n> Stay hungry; stay foolish.\n>> Quality is better than quantity.\n>>> Life is not fair; get used to it.\n\n<br/>\n<div align=\"right\">\n    <b><a href=\"#top \">\u21A5 back to top</a></b>\n</div>\n<br/>\n\n### COMMENT\n\n    [/]:# (This is a comment, you cannot see it)\n\n[/]:# (This is a comment, you cannot see it)\n\n<br/>\n<div align=\"right\">\n    <b><a href=\"#top \">\u21A5 back to top</a></b>\n</div>\n<br/>\n\n### CODE\n\n    inline code- `int i=0`\n\n    block code-\n    ``` C\n    for(int i=0; i<10; i++){\n        printf(\"Hallow World! \n\");\n    }\n    ```\n\ninline code- `int i=0`\n\nblock code-\n``` C\nfor(int i=0; i<10; i++){\n    printf(\"Hallow World! \n\");\n}\n```\n\n<br/>\n<div align=\"right\">\n    <b><a href=\"#top \">\u21A5 back to top</a></b>\n</div>\n<br/>\n\n### GITHUB EMOJI\n\n    :octocat: :rabbit: :alien: :+1: :bee: :bell: :ghost: :bulb: :imp:\n\n:octocat: :rabbit: :alien: :+1: :bee: :bell: :ghost: :bulb: :imp:\n\n[more...](https://github.com/scotch-io/All-Github-Emoji-Icons)\n\n<br/>\n<div align=\"right\">\n    <b><a href=\"#top \">\u21A5 back to top</a></b>\n</div>\n<br/>\n\n### OTHERS\n\n    Which one does @torvalds like most?\n    - [ ] tiger #\n    - [ ] whale *\n    - [X] octocat !\n\n\nWhich one does @torvalds like most?\n- [ ] tiger #\n- [ ] whale *\n- [X] octocat !\n\n<br/>\n<div align=\"right\">\n    <b><a href=\"#top \">\u21A5 back to top</a></b>\n</div>\n<br/>\n\n### HTML TAGS\n\n    <div align=\"center\">\n        <kbd>Markdown</kbd> also supports &#9608; <b>HTML</b> &#9608; <i>syntax</i> <!--invisible--> <br/>\n        <a href=\"http://www.youtube.com/watch?feature=player_embedded&v=vq2jYFZVMDA\" target=\"_blank\">\n            <img src=\"http://img.youtube.com/vi/vq2jYFZVMDA/0.jpg\" alt=\"GitHub Video\"\n            border=\"10\" width=\"460\" height=\"250\"/>\n        </a>\n    </div>\n\n<div align=\"center\">\n    <kbd>Markdown</kbd> also supports &#9608; <b>HTML</b> &#9608; <i>syntax</i> <!--invisible--> <br/>\n    <a href=\"http://www.youtube.com/watch?feature=player_embedded&v=vq2jYFZVMDA\" target=\"_blank\">\n        <img src=\"http://img.youtube.com/vi/vq2jYFZVMDA/0.jpg\" alt=\"GitHub Video\"\n        border=\"10\" width=\"460\" height=\"250\"/>\n    </a>\n</div>\n\n<br/>\n<div align=\"right\">\n    <b><a href=\"#top \">\u21A5 back to top</a></b>\n</div>\n<br/>\n\n### TEXT ART\n\n```\nroot                         \u250C\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2510             \u250C\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2510\n \u251C\u2500branch-1                  |        Vehicle        \u251C\u2500\u2500 has-a \u2500\u2500\u2500\u2192|    Engine    |\n \u2502  \u251C\u2500sub-branch-1           \u2514\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2518             \u2514\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2518\n \u2502  \u2514\u2500sub-branch-2                 \u2191              \u2191                      \u2191   \u2191                 top --\\\n \u251C\u2500branch-2                        |              |                      |   |                 \u2524 ^_^ |\n \u2502  \u2514\u2500sub-branch-3                 |            is-a                     |   |                 \u2514\u2500\u2500-\u2500\u2500\u2518\n \u2502     \u251C\u2500a                         |              |                      |   |\n \u2502     \u2514\u2500b                         |         \u250C\u2500\u2500\u2500\u2500\u2534\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2510            |   |\n \u251C\u2500branch-3                       is-a       |    Toyota    \u251C\u2500\u2500 has-a \u2500\u2500\u2500\u2518   |                 top --\\\n \u2502  \u2514\u2500sub-branch-4                 |         \u2514\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2518                |                 \u2524 @_@ |\n \u2514\u2500branch-4                        |                                       is-a                \u2514\u2500\u2500-\u2500\u2500\u2518\n    \u251C\u2500sub-branch-5                 |                                         |\n    \u251C\u2500sub-branch-6           \u250C\u2500\u2500\u2500\u2500\u2500\u2534\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2510                     \u250C\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2534\u2500\u2500\u2500\u2500\u2510\n    \u2502  \u2514\u2500c                   \u2502   Lamborghini  \u251C\u2500\u2500\u2500\u2500\u2500\u2500\u2500has-a \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2192\u2502  V12 Engine \u2502\n    \u2514\u2500sub-branch-7           \u2514\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2518                     \u2514\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2518\n```\n\n<br/>\n<div align=\"right\">\n    <b><a href=\"#top \">\u21A5 back to top</a></b>\n</div>\n<br/>\n\n#### References\n- https://github.com/adam-p/markdown-here/wiki/Markdown-Cheatsheet\n- https://daringfireball.net/projects/markdown/syntax\n- http://learn.getgrav.org/content/markdown\n- https://confluence.atlassian.com/bitbucketserver/markdown-syntax-guide-776639995.html\n\n<br/>\n<div align=\"right\">\n    <b><a href=\"#top \">\u21A5 back to top</a></b>\n</div>\n<br/>\n";


/***/ }),

/***/ 79:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pagetop; });
var pagetop = "<a id=\"page-top\"></a>\n\n# Example of returning to page top\n\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc tellus lorem, convallis at ligula sit amet, eleifend porttitor lacus. Praesent sagittis, lectus nec finibus pharetra, leo est viverra erat, in tincidunt est mauris ut orci. Nulla augue eros, scelerisque ornare justo in, ultricies sagittis felis. Suspendisse potenti. Phasellus in urna eros. Mauris mollis urna vel elit vulputate lacinia. Sed nisl ipsum, mattis sed cursus ac, vehicula ut metus. Curabitur ligula nisi, fringilla fermentum finibus et, pretium id velit. Vivamus consequat purus nec molestie efficitur. Aenean mauris ante, commodo vel bibendum in, auctor ac tortor.\n\nProin at metus ac lacus hendrerit consequat quis ut nunc. Integer id sapien nisl. Mauris enim lorem, fermentum vel est a, venenatis scelerisque metus. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Proin consectetur odio et erat dictum lobortis. Donec non aliquet lorem, vitae porttitor mauris. Nulla imperdiet dictum neque ut congue. Integer tincidunt urna urna, ac ultricies nulla bibendum vitae. Aenean vestibulum porttitor risus, pretium dapibus leo lacinia vel. Praesent hendrerit nunc id erat convallis, id fringilla tortor ullamcorper. Sed commodo sit amet nibh a pellentesque. Ut auctor purus neque, eu ornare ex vulputate eu. Morbi lobortis magna et dictum egestas. Fusce et risus porttitor, fermentum lacus eget, porttitor lorem. Nullam et iaculis nunc.\n\n## Subheading\n\nNulla molestie, justo id laoreet vehicula, quam neque faucibus lorem, quis ornare libero ante sed neque. Quisque vestibulum pellentesque rhoncus. Suspendisse volutpat quam eu dui sagittis, eu convallis orci cursus. Integer luctus lorem ac consectetur congue. Nunc faucibus, elit sit amet sagittis condimentum, orci nunc laoreet quam, non commodo leo arcu eget lorem. Curabitur at tristique nisi. Donec vitae porta orci. Aliquam mollis odio fringilla dolor malesuada, sed ornare sapien commodo. In vel nulla vel turpis pellentesque eleifend.\n\nFusce sodales bibendum elementum. Proin pulvinar eros non orci ornare posuere. Aenean nec ipsum fermentum, imperdiet urna quis, sodales nibh. Mauris sagittis in purus in lobortis. In dictum, tortor non convallis rhoncus, nulla ex laoreet mauris, quis efficitur diam libero at tellus. Nulla vestibulum vitae sem eget elementum. Praesent commodo, diam sed tempor sodales, dui sapien lacinia erat, nec porttitor ligula purus quis purus. Nulla tincidunt odio non magna viverra faucibus in sed ante. Praesent condimentum mi id lacus faucibus maximus. Curabitur ut mollis massa. Maecenas nisl mi, efficitur at sapien ac, congue facilisis purus. In et ligula vitae lectus sodales sodales in in est. Integer aliquet luctus consequat. Pellentesque id lobortis magna.\n\n## Subheading\n\nNullam id urna et risus commodo sodales bibendum volutpat erat. Interdum et malesuada fames ac ante ipsum primis in faucibus. Vivamus congue fringilla tellus, non efficitur nibh rhoncus vel. Sed eget porta magna, a volutpat lectus. Donec pretium ligula sit amet quam iaculis, a placerat mauris consectetur. Vestibulum nec nisi lobortis, tristique risus quis, laoreet magna. Donec interdum dignissim nisi dictum dapibus. Pellentesque ultrices consequat arcu sit amet consequat. Duis ut molestie sapien. Nam interdum laoreet nisi id dictum.\n\n[Back to Top](#page-top)\n\n";


/***/ }),

/***/ 80:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return readme; });
var readme = "# icjia-markdown\n\nMarkdown is a lightweight text format that allows writers to create documents, rich text, or HTML markup using any text editor. Markdown documents are easy to read, write, and convert into multiple formats.\n\nThis editor was created in order to facilitate ICJIA's in-house web publishing process. I used the [Markdown editor example](https://vuejs.org/v2/examples/) in the [Vue.js documentation](https://vuejs.org/) as the starting point.\n\nThis uses a [Loopback API](http://loopback.io) to store user-generated permalinks. [Code for the API is here](https://github.com/ICJIA/icjia-api).\n\nThe API is hosted by [Now](https://zeit.co/now) and uses MySQL.\n\nAn instance of MySQL is running on a [DigitalOcean](https://www.digitalocean.com/) droplet.\n\nThis markdown editor is hosted on [Netlify](https://www.netlify.com/) static hosting.\n\n## For more information about markdown\n\n- [https://daringfireball.net/projects/markdown/syntax](https://daringfireball.net/projects/markdown/syntax)\n- [https://help.github.com/articles/basic-writing-and-formatting-syntax/](https://help.github.com/articles/basic-writing-and-formatting-syntax/)\n-  [http://commonmark.org/help/tutorial/](http://commonmark.org/help/tutorial/)\n\n\n## Build Setup\n\n``` bash\n# install dependencies\nnpm install\n\n# serve with hot reload at localhost:8080\nnpm run dev\n\n# build for production with minification\nnpm run build\n\n# build for production and view the bundle analyzer report\nnpm run build --report\n\n```\n## Main dependencies\n- [Bootstrap 3.3.7](http://getbootstrap.com/)\n- [jQuery](https://jquery.com/)\n- [webui-popover](https://github.com/sandywalker/webui-popover)\n- [Vue](https://vuejs.org/)\n- [Webpack](https://webpack.js.org/)\n- [Vue-CLI Webpack template](https://github.com/vuejs-templates/webpack)\n- [Lodash](https://lodash.com/)\n- [Moment.js](https://momentjs.com/)\n- [Markdown-it](https://github.com/markdown-it/markdown-it)\n\n### Syntax Extensions\n\n- [Markdown-it-footnote](https://github.com/markdown-it/markdown-it-footnote)\n- [Markdown-it-fontawesome](https://github.com/nunof07/markdown-it-fontawesome)\n- [Markdown-it-attrs](https://github.com/arve0/markdown-it-attrs)\n- [Markdown-it-katex](https://github.com/waylonflinn/markdown-it-katex)\n\n## Live site\n\nhttps://markdown.icjia.cloud\n\n\n## Direct deploy\n\n[![Deploy to Netlify](https://www.netlify.com/img/deploy/button.svg)](https://app.netlify.com/start/deploy?repository=https://github.com/ICJIA/icjia-markdown)";


/***/ }),

/***/ 81:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tables; });
var tables = "# Tables in Markdown\nItem     | Value\n-------- | ---\nComputer | $1600\nPhone    | $12\nPipe     | $1\n\nYou can specify column alignment with one or two colons:\n\n| Item     | Value | Qty   |\n| :------- | ----: | :---: |\n| Computer | $1600 |  5    |\n| Phone    | $12   |  12   |\n| Pipe     | $1    |  234  |\n";


/***/ }),

/***/ 82:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export toc */
var toc = "# Heading\n\n[[toc]]\n\n## Sub heading 1\n\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque tempor varius quam ac iaculis. Mauris bibendum porta volutpat. Cras mollis nec tellus non gravida. Vivamus ullamcorper, dolor ut sollicitudin porta, dui lacus ultricies nunc, ut elementum turpis velit interdum ligula. Aenean eget pellentesque tortor. In a dolor eu dui elementum consectetur eu ac lacus. Cras luctus pretium fermentum. Vestibulum mauris ligula, molestie a felis ut, condimentum porttitor dui. Vivamus lacinia nisl id odio cursus, non euismod nisl eleifend. Vivamus libero sem, laoreet in vulputate vitae, malesuada a ex. Donec eget massa quam.\n\n## Sub heading 2\n\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque tempor varius quam ac iaculis. Mauris bibendum porta volutpat. Cras mollis nec tellus non gravida. Vivamus ullamcorper, dolor ut sollicitudin porta, dui lacus ultricies nunc, ut elementum turpis velit interdum ligula. Aenean eget pellentesque tortor. In a dolor eu dui elementum consectetur eu ac lacus. Cras luctus pretium fermentum. Vestibulum mauris ligula, molestie a felis ut, condimentum porttitor dui. Vivamus lacinia nisl id odio cursus, non euismod nisl eleifend. Vivamus libero sem, laoreet in vulputate vitae, malesuada a ex. Donec eget massa quam.\n";


/***/ }),

/***/ 83:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return welcome; });
var welcome = "# Welcome!\n\n> To get started, please select a **Boilerplate** or press `CLEAR` and start typing, or take the `Tutorial` above.\n\n## What is Markdown?\n\n> Markdown is a lightweight markup language with plain text formatting syntax. Markdown is often used to format readme files, to write messages in online discussion forums, and to create rich text using a plain text editor.\n\n> Markdown is easily converted to HTML.\n\n### For more information, please see:\n\n- [https://en.wikipedia.org/wiki/Markdown](https://en.wikipedia.org/wiki/Markdown)\n\n- [https://help.github.com/articles/basic-writing-and-formatting-syntax](https://help.github.com/articles/basic-writing-and-formatting-syntax)\n\n";


/***/ }),

/***/ 84:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tether__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tether___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_tether__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scss_style_scss__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scss_style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__scss_style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__googleAnalytics_js__ = __webpack_require__(38);
// import jquery from 'jquery'










__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].config.productionTip = false;

////////////////////////////////////////////////////////////////////////////////////
// Custom Google Analytics injection. Modified from vue-ga
////////////////////////////////////////////////////////////////////////////////////
window['NODE_ENV'] = "production";
if (NODE_ENV === 'production') {

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__googleAnalytics_js__["a" /* default */])('UA-10798495-22', 'ICJIA | ', __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */]);
}

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_5__App___default.a }
});

/***/ }),

/***/ 85:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultTemplate; });
function defaultTemplate(body) {
  return "\n  <html>\n    <head>\n    <meta charset=\"utf-8\">\n    <title>MARKDOWN to STYLED HTML</title>\n    <meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\">\n    <meta name=\"viewport\" content=\"width=device-width, initial-scale=1, maximum-scale=1\" />\n    <script src=\"https://use.fontawesome.com/2b0dc300da.js\"></script>\n    <link href=\"https://fonts.googleapis.com/css?family=Lato:400,700,900\" rel=\"stylesheet\">\n\n    <link rel=\"stylesheet\" href=\"https://cdnjs.cloudflare.com/ajax/libs/KaTeX/0.5.1/katex.min.css\">\n    <link rel=\"stylesheet\" href=\"https://cdn.jsdelivr.net/github-markdown-css/2.2.1/github-markdown.css\"/>\n      <style>\n      body {margin: 0; padding: 0}\n      .markdown-body { margin: 15px 30px 30px 30px !important; font-family: 'Lato', sans-serif !important;}\n      .markdown-body  table  {\n           border-collapse:  collapse;\n           text-align:  left;\n           width:  100% !important;\n           margin-bottom: 20px;\n           display: inline-table;\n       }\n\n      .markdown-body  table td,  .markdown-body  table th  {\n           padding:  3px 10px;\n       }\n      .markdown-body  table thead th  {\n          background: -webkit-gradient( linear,  left top,  left bottom,  color-stop(0.05,  #8C8C8C),  color-stop(1,  #7D7D7D) );\n          background: -moz-linear-gradient( center top,  #8C8C8C 5%,  #7D7D7D 100% );\n          filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#8C8C8C',  endColorstr='#7D7D7D');\n          background-color: #8C8C8C;\n           color: #FFFFFF;\n           font-size:  15px;\n           font-weight:  bold;\n           border-left:  1px solid #A3A3A3;\n       }\n       .markdown-body  table thead th:first-child  {\n           border:  none;\n       }\n      .markdown-body  table tbody td  {\n           color:  #7D7D7D;\n           border-left:  1px solid #DBDBDB;\n          font-size:  12px;\n          font-weight:  normal;\n       }\n      .markdown-body  table tbody .alt td  {\n           background:  #EBEBEB;\n           color:  #7D7D7D;\n       }\n      .markdown-body  table tbody td:first-child  {\n           border-left:  none;\n       }\n      .markdown-body  table tbody tr:last-child td  {\n           border-bottom:  none;\n       }\n      .markdown-body  table tfoot td div  {\n           border-top:  1px solid #8C8C8C;\n          background:  #EBEBEB;\n      }\n       .markdown-body  table tfoot td  {\n           padding:  0;\n           font-size:  12px }\n       .markdown-body  table tfoot td div {\n           padding:  2px;\n       }\n      .markdown-body  table tfoot td ul  {\n           margin:  0;\n           padding: 0;\n           list-style:  none;\n           text-align:  right;\n       }\n      .markdown-body  table tfoot  li  {\n           display:  inline;\n       }\n      .markdown-body  table tfoot li a  {\n           text-decoration:  none;\n           display:  inline-block;\n            padding:  2px 8px;\n           margin:  1px;\n          color:  #F5F5F5;\n          border:  1px solid #8C8C8C;\n          -webkit-border-radius:  3px;\n           -moz-border-radius:  3px;\n           border-radius:  3px;\n           background: -webkit-gradient( linear,  left top,  left bottom,  color-stop(0.05,  #8C8C8C),  color-stop(1,  #7D7D7D) );\n          background: -moz-linear-gradient( center top,  #8C8C8C 5%,  #7D7D7D 100% );\n          filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#8C8C8C',  endColorstr='#7D7D7D');\n          background-color: #8C8C8C;\n       }\n      .markdown-body  table tfoot ul.active,  .markdown-body  table tfoot ul a:hover  {\n           text-decoration:  none;\n          border-color:  #7D7D7D;\n           color:  #F5F5F5;\n           background:  none;\n           background-color: #8C8C8C;\n      }\n\n\n      .markdown-body  h1,\n      .markdown-body  h2,\n      .markdown-body  h3,\n      .markdown-body  h4,\n      .markdown-body  h5 {margin-bottom: 20px; font-weight: 900 !important}\n      .markdown-body  img {margin-bottom: 40px;}\n\n      footer {\n          background: #eee;\n          padding-top: 15px;\n          padding-bottom: 15px;\n          margin-top: 50px;\n          border-top: 1px solid #ccc;\n          border-bottom: 1px solid #ccc;\n          text-align: center;\n          font-weight: 900;\n          text-transform: uppercase;\n          font-family: 'Lato', sans-serif;\n           font-size: 12px;\n      }\n\n\n\n      </style>\n\n    </head>\n    <body>\n      <div class=\"markdown-body\">\n      " + body + "\n      </div>\n\n      <footer class=\"footer\" style=\"\">\n      <p><a href=\"https://markdown.icjia.cloud\">ICJIA Markdown Editor</a>&nbsp;&nbsp;|&nbsp;&nbsp;<i class=\"fa fa-github\" aria-hidden=\"true\"></i>&nbsp;<a href=\"https://github.com/ICJIA/icjia-markdown\">View on Github</a></p>\n      </footer>\n\n    </body>\n  </html>\n  ";
}



/***/ }),

/***/ 98:
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ })

},[84]);


// WEBPACK FOOTER //
// static/js/app.ac013085d1e235c49e0e.js